import React, { useContext, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Link,
  NavLink,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { CONFIG } from './config';

import TranslationPage from './pages/translation-page/translation-page.component';
import UsersPage from './pages/users-page/users-page.component';
import TagsPage from "./pages/tags-page/tags-page.component";
import CategoriesPage from "./pages/categories-page/categories-page.component";
import TranslationKeysPage from "./pages/translation-keys-page/translation-keys-page.component";
import HelpTutorialPage from "./pages/help-tutorial-page/help-tutorial-page.component";

import { Context, ContextProvider } from './state/context';
import LoginPage from './pages/login-page/login-page.component';
import { ROLE } from './enums/roles';
import { hasRole } from './utils/hasRole';


function UnauthorizedPage() {
  return (
    <div className={'container'}>
      <div className={'alert alert-danger'}>
        <b>Error:</b> You are unauthorized
      </div>
      <div>
        Go to <Link to={'/login'}> Log in </Link>
      </div>
    </div>
  )
}

function Routes() {
  const { dispatch, state } = useContext(Context)
  const [roles, setRoles] = useState([])
  const [redirect, setRedirect] = useState(false)
  const [authKey, setAuthKey] = useState('');
  const [language, setLanguage] = useState('');

  const languages = localStorage.getItem('userLanguages');
  let languageTag = '';

  if (typeof languages !== 'undefined') {
    let parsedLanguages = JSON.parse(languages);
    if (parsedLanguages !== null && typeof parsedLanguages[0] !== 'undefined')
      languageTag = parsedLanguages[0];
  }

  useEffect(() => {
    setAuthKey(state.authKey)
  }, [state.authKey])

  useEffect(() => {
    setLanguage(state.language)
  }, [state.language])

  useEffect(() => {
    setRoles(state.roles)
  }, [state.roles])

  const history = createBrowserHistory();
  const handleLogout = () => {
    localStorage.removeItem('auth_key')
    localStorage.removeItem('roles')
    localStorage.removeItem('userLanguages')
    dispatch({ type: 'SET_AUTH_KEY', authKey: '' });
    dispatch({ type: 'SET_ROLES', roles: [] });
    dispatch({ type: 'SET_LANGUAGE', language: '' });
    dispatch({ type: 'SET_DELETED', deleted: [] });
    dispatch({ type: 'SET_DRAFTS', drafts: [] });
    dispatch({ type: 'SET_KEYS', keys: [] });
    setRedirect(true);
    history.push('/login');
  }
  return (
    <Router basename={CONFIG.frontBasename}>
      <nav className={'navbar navbar-expand-lg navbar-dark bg-blue sticky-top d-flex justify-content-between'}>
        <span className="navbar-brand"><img src={process.env.PUBLIC_URL + '/logo.png'} alt="Mondly logo" height="40" /></span>
        <ul className="navbar-nav flex-row">
          {!authKey && <>
            <li className="nav-item">
              <NavLink className={'nav-link'} activeStyle={{ color: '#fff' }}
                to="/login">Login</NavLink>
            </li>
          </>}
          {authKey && <>

            <li className="nav-item mr-3">
              <NavLink className={'nav-link'} activeStyle={{ color: '#fff' }}
                to={{ pathname: `/translation/${languageTag}` }}>Translations</NavLink>
            </li>
            {(hasRole(roles, ROLE.ADMIN) || hasRole(roles, ROLE.LANGUAGES) || hasRole(roles, ROLE.MARKETING)) && <li className="nav-item mr-3">
              <NavLink className={'nav-link'} activeStyle={{ color: '#fff' }}
                       to={{ pathname: `/tags` }}>Tags</NavLink>
            </li>}
            {(hasRole(roles, ROLE.ADMIN) || hasRole(roles, ROLE.LANGUAGES) || hasRole(roles, ROLE.MARKETING)) && <li className="nav-item mr-3">
              <NavLink className={'nav-link'} activeStyle={{ color: '#fff' }}
                to={{ pathname: `/categories` }}>Categories</NavLink>
            </li>}
            {(hasRole(roles, ROLE.ADMIN) || hasRole(roles, ROLE.LANGUAGES) || hasRole(roles, ROLE.MARKETING)) && <li className="nav-item mr-3">
              <NavLink className={'nav-link'} activeStyle={{ color: '#fff' }}
                       to={{ pathname: `/keys` }}>Keys</NavLink>
            </li>}
            {(hasRole(roles, ROLE.ADMIN) || hasRole(roles, ROLE.LANGUAGES) || hasRole(roles, ROLE.MARKETING)) && <li className="nav-item mr-3">
              <NavLink className={'nav-link'} activeStyle={{ color: '#fff' }}
                to={{ pathname: `/users` }}>Users</NavLink>
            </li>}
            <li className="nav-item mr-3 dropdown">
              <a className="nav-link dropdown-toggle" href="#" id="helpDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Help
              </a>
              <div className="dropdown-menu" aria-labelledby="helpDropdown">
                <NavLink className={'nav-link'} activeStyle={{ color: '#333' }}
                  to={{ pathname: `/help/tutorial` }}>Tutorial</NavLink>
              </div>
            </li>
            <li className="nav-item pl-3 nav-separator">
              <NavLink className={'nav-link'} activeStyle={{ color: '#fff' }}
                to="/logout" onClick={handleLogout}>Logout</NavLink>
            </li>
          </>}
        </ul>

      </nav>
      <Switch>
        <Route exact path="/">
          {hasRole(roles, ROLE.TRANSLATOR) ? <Redirect to={{ pathname: `/translation/${languageTag}` }} /> : <Redirect to="/login" />}
        </Route>

        <Route exact path={'/login'}>
          <LoginPage />
        </Route>

        <Route exact path={'/translation/:language'}>
          {hasRole(roles, ROLE.TRANSLATOR) ? <TranslationPage /> :
            <UnauthorizedPage />}
        </Route>

        <Route exact path={'/users'}>
          {(hasRole(roles, ROLE.ADMIN) || hasRole(roles, ROLE.LANGUAGES) || hasRole(roles, ROLE.MARKETING)) ? <UsersPage /> :
            <UnauthorizedPage />}
        </Route>

        <Route exact path={'/tags'}>
          {(hasRole(roles, ROLE.ADMIN) || hasRole(roles, ROLE.LANGUAGES) || hasRole(roles, ROLE.MARKETING)) ? <TagsPage /> :
              <UnauthorizedPage />}
        </Route>

        <Route exact path={'/categories'}>
          {(hasRole(roles, ROLE.ADMIN) || hasRole(roles, ROLE.LANGUAGES) || hasRole(roles, ROLE.MARKETING)) ? <CategoriesPage /> :
            <UnauthorizedPage />}
        </Route>

        <Route exact path={'/keys'}>
          {(hasRole(roles, ROLE.ADMIN) || hasRole(roles, ROLE.LANGUAGES) || hasRole(roles, ROLE.MARKETING)) ? <TranslationKeysPage /> :
              <UnauthorizedPage />}
        </Route>

        <Route exact path={'/help/tutorial'}>
          {(hasRole(roles, ROLE.ADMIN) || hasRole(roles, ROLE.LANGUAGES) || hasRole(roles, ROLE.MARKETING) || hasRole(roles, ROLE.TRANSLATOR)) ? <HelpTutorialPage /> :
            <UnauthorizedPage />}
        </Route>

        <Route path="/logout">
          {redirect ? <Redirect to="/login" /> : <TranslationPage />}
        </Route>
      </Switch>

    </Router>

  )
}

export default function App() {
  return (
    <div>

      <ContextProvider>
        <div>
          <Routes />
        </div>
      </ContextProvider>
    </div>
  )
}
